const state = {
  timezonesGlobal: [],
  teams: [],
  selectedTeam: {},
  selectedTeamMembers: {},
  countries: {},
  teamRole: '',
  createdTeamId: undefined,
  userStartOfWeek: 'Monday',
  stripeScriptLoaded: false,
  userSettings: {},
  preventScheduleLeave: false,
  pLeaveFlag: true,
  showProgressBar: false,
  bufferedTeamsSchedules: {},
  bufferedUsersSchedules: {},
  bufferedTeamsNotifications: {},
  bufferedTeamsOverdueStatus: {},
  holidayInfo: {},
  followedList: {},
  copiedEntry: {},
  isNotificationsPanelOpen: true,
  showListOfLateTeamMembers: false,
  tempTimeOffChanges: {},
  isMonthMode: false,
  teamsNotToAskAboutLeaveDays: [],
}

export default state
